export default __webpack_public_path__ + "static/media/feedback.e5420b11.png";